import { render, staticRenderFns } from "./FileQuestion.vue?vue&type=template&id=6bd1ee3e&scoped=true"
import script from "./FileQuestion.vue?vue&type=script&lang=ts"
export * from "./FileQuestion.vue?vue&type=script&lang=ts"
import style0 from "./FileQuestion.vue?vue&type=style&index=0&id=6bd1ee3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1ee3e",
  null
  
)

export default component.exports